const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
const LCP_LOGO_WEBP = `${publicUrl}/logo.webp`;
const WORDMARK_LOGO_WEBP = `${publicUrl}/Apily-Logo.webp`;

export default function ApilyLogo({ compact = false, wordmark = false, className = "" }) {
  if (wordmark) {
    return (
      <img
        src={WORDMARK_LOGO_WEBP}
        alt="Apily"
        className={`logo-image-wordmark ${className}`.trim()}
        width="480"
        height="179"
        fetchPriority="high"
        loading="eager"
        decoding="async"
        draggable="false"
      />
    );
  }

  return (
    <img
      src={LCP_LOGO_WEBP}
      alt="Apily"
      className={`logo-image ${compact ? "logo-image-compact" : ""} ${className}`.trim()}
      width="96"
      height="96"
      fetchPriority="high"
      loading="eager"
      decoding="async"
      draggable="false"
    />
  );
}
